import Map from '../plugins/PluginMap.ts'

declare const markers: any
declare const markersLocation: any

window.addEventListener('load', () => {
  // Init map
  const mapContainer =
    document.querySelectorAll<HTMLElement>("[data-item='map']")
  if (mapContainer.length > 0) {
    mapContainer.forEach((container: HTMLElement) => {
      const map = new Map(container, {
        accessToken: container.dataset.token,
        centerLatitude: container.dataset.lat as string,
        centerLongitude: container.dataset.lng as string,
        coordinates: markers,
        zoom: 9,
      })
    })
  }

  const mapContainerLocation = document.querySelectorAll<HTMLElement>(
    "[data-item='map-location']",
  )
  if (mapContainerLocation.length > 0) {
    mapContainerLocation.forEach((container: HTMLElement) => {
      let lat: any = container.dataset.lat

      if (window.innerWidth >= 992) {
        lat = parseFloat(container.dataset.lat as string) + 0.0025
      }

      const map = new Map(container, {
        accessToken: container.dataset.token,
        centerLatitude: lat,
        centerLongitude: container.dataset.lng as string,
        coordinates: markersLocation,
        zoom: 11,
      })
    })
  }
})
